import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { MerchantProvisionRepository } from '@app/domain/ports/tpv/merchant-provision.repository';
import { MerchantProvisionResult } from '@app/domain/models/tpv/merchant.model';
import {
  ProvisionAssistedRequest,
  ProvisionMerchantRequest,
  ProvisionMerchantCompanyAnchoredRequest,
} from '@app/data/dtos/tpv/provision.dto';

/**
 * Mock del alta de comercios para pruebas sin backend (toggle tpvUseMocks).
 * Simula latencia y devuelve un external_id_merchant (UUID) de prueba.
 */
@Injectable()
export class MerchantProvisionMockDataSource extends MerchantProvisionRepository {
  override provision(
    request: ProvisionMerchantRequest,
    _idempotencyKey: string,
  ): Observable<MerchantProvisionResult> {
    return of(this.buildResult(request.polipay_account_id)).pipe(delay(600));
  }

  override provisionAssisted(
    request: ProvisionAssistedRequest,
    _idempotencyKey: string,
  ): Observable<MerchantProvisionResult> {
    return of(this.buildResult(request.polipay_account_id)).pipe(delay(600));
  }

  override provisionCompanyAnchored(
    _idCompany: string,
    _request: ProvisionMerchantCompanyAnchoredRequest,
    _idempotencyKey: string,
  ): Observable<MerchantProvisionResult> {
    return of(this.buildResult()).pipe(delay(600));
  }

  private buildResult(polipayAccountId: number | string = 0): MerchantProvisionResult {
    const uuid =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `mock-${polipayAccountId}-${Date.now().toString(36)}`;
    return {
      polipayAccountId: Number(polipayAccountId) || 0,
      externalIdMerchant: uuid,
      status: 'provisioned',
    };
  }
}
